import classNames from 'classnames';
import React from 'react';
import { Tbody as ResponsiveTbody } from 'react-super-responsive-table';
import styles from './index.module.scss';

export const Tbody: React.FC<React.HTMLAttributes<HTMLTableSectionElement>> = props => {
  const { children, className, ...rest } = props;
  const containerClass = classNames(styles.tbody, className);

  return (
    <ResponsiveTbody {...rest} className={containerClass}>
      {children}
    </ResponsiveTbody>
  );
};
